import { RootAppState } from 'store/configureStore'

export const bomItemCommentSelector =
  (bomItemId: string) => (state: RootAppState) => {
    if (!bomItemId || !state.project) {
      return null
    }

    if (bomItemId === state.project.activeProject?.id) {
      return state.project.activeProject.comment
    }

    const bomItem =
      state.project.flatView &&
      (state.project.flatView[bomItemId] || state.project.treeView[bomItemId])

    switch (bomItem?.type) {
      case 'AssemblyHeader': {
        return bomItem.assembly.comment
      }
      case 'Row':
      case 'Assembly': {
        return bomItem.comment
      }
      default: {
        return null
      }
    }
  }

export const bomItemHasComment =
  (bomItemId: string) => (state: RootAppState) => {
    return bomItemCommentSelector(bomItemId)(state)?.length > 0
  }
